// 场景底图（EP-004-S4）—— 满幅底图，作为最底层。
// 🆕 v2.2（2026-09-18）：在家/等揭晓时随机「房间」或「庭院」底图。
//   随机时机绑定 phase 变化：每次进入 home / awaitingReveal 重掷一次（即每趟旅行回家换一张），
//   同一次在家期间保持稳定，避免 React 重渲染导致背景来回跳变。
//   away 态沿用上一次的选择（狗不在家，背景只是衬托，不重掷）。
import { useEffect, useState } from 'react';
import { useGameStore, selectPhase } from '../store';
import { assetIndex } from '../assets/assetIndex';

type HomeSceneId = 'room_day' | 'scene_yard_day';

const HOME_SCENES: readonly HomeSceneId[] = ['room_day', 'scene_yard_day'];

function pickRandomScene(): HomeSceneId {
  return HOME_SCENES[Math.floor(Math.random() * HOME_SCENES.length)] ?? 'room_day';
}

export function SceneView() {
  const phase = useGameStore(selectPhase);
  const [sceneId, setSceneId] = useState<HomeSceneId>(pickRandomScene);

  useEffect(() => {
    if (phase === 'home' || phase === 'awaitingReveal') {
      setSceneId(pickRandomScene());
    }
  }, [phase]);

  return (
    <div className="scene-room">
      <img className="scene-room__img" src={assetIndex[sceneId]} alt="" aria-hidden="true" />
    </div>
  );
}
